import { Component, OnInit , ViewChild, ElementRef} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IScenario, ScenarioService } from './scenario.service';
import { UserSession } from '../shared/user-session';
import { AuthService } from '../authentication/auth.service';
import {Messages} from 'primeng/primeng';
import { UserInfoService } from '../shared/user-info.service';

@Component({
    template: require('./scenario-delete-list.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES]
})

export class ScenarioDeleteListComponent implements OnInit {
    pageTitle: string = 'Scenario Delete';
    errorMessage: string;
    currentScenario: IScenario;
    scenarios: IScenario[];
    selectedOptionValues: number[];
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    msgs: Messages[]=[];
    msgResponse: any;
    displayPage:string ="false"
    isScenarioOwner: boolean = false;
    ownScenarios:string ="true";

    constructor(private route: ActivatedRoute,
        private router: Router,
        private _scenarioService: ScenarioService,
        private _User: UserSession, 
        private _userInfoService: UserInfoService,
        private authService: AuthService
    ) { }
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit(): void {


         this._scenarioService.getScenarios(this._User.getSession()['id'])
            .subscribe(
            scenarios => {this.allScenarios = scenarios; console.log("scenarios:" + this.allScenarios[0].scenarioName)},
            error => this.errorMessage = <any>error,
            () => {
                if (this._User.hasValidSession()){
                    this.setScenarioHeader(this._User.getSession().scenarioId);
                  
                }
                else {
                    this.setScenarioHeader(this._User.scenarioId);
                    this._User.updateSessionState();
                }
            }
        );
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        if(typeof(this._User.scenarioId) === 'undefined')
            this.router.navigate(['./scenario-activities']);

        this._userInfoService.isScenarioOwner(this._User.getSession()['id'], this._User.getSession().scenarioId).subscribe(
            success =>{ this.isScenarioOwner = success.isOwner; 
                if(this.isScenarioOwner == false && this._User.isAdmin == false){
                    this.ownScenarios="false";
                    this.msgs = [];
                    this.msgs.push({severity:'warn', summary:'Warn Message', detail:'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.'});
                }
            },
            error => this.errorMessage = <any>error
        );

        this._scenarioService.getDeleteListScenarios(this._User.userId)
            .subscribe(
            scenarios => this.scenarios = scenarios,
            error => this.errorMessage = <any>error
            );
        this.displayPage="true";
        this.selectedOptionValues = [];
    }
    private setScenarioHeader(scenarioId: number): void {
        let foundScenarios: IScenario[] = this.allScenarios.filter(function (scenario) {
            return scenario.id === scenarioId;
        });
        if (foundScenarios.length > 0) {
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
    deleteScenarios(): void {
        this._scenarioService.deleteScenarios(this.selectedOptionValues)
            .subscribe(
                    msgResponse=>this.msgResponse = msgResponse,
                    error => this.errorMessage = <any>error,
                    () => {
                        //console.log("delete response" + this.msgResponse.length);
                        if (this.errorMessage) {
                            this.msgs=[];
                            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Delete scenario error"' + this.errorMessage });
                            return;
                        }
                        else{   this.displayPage ="true";
                        }
                        window.location.reload();
                       // this.router.navigate(['./scenario-activities']);
                    }
            );
    }

        updateOptionsList(optionInt: number): void {
        this.selectedOptionValues.push(optionInt);
    }

    cancelDelete(): void {
        this.router.navigate(['./scenario-activities']);
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-delete-list.component.ts
 **/